import type { AreaGroup } from '@/types/api'
import styles from './AreaPricingPage.module.css'

/**
 * The colour each group is drawn in, on the map and beside its name in the
 * lists, so a polygon and the row it belongs to read as one thing.
 *
 * The primary group is green — it adds nothing — and a sub-area in no group is
 * grey and dashed. The others take the status hues and then the brand in the
 * order the page lists them, which is stable: the primary group first, then by
 * name.
 */
const GROUP_TONES = [styles.tone0, styles.tone1, styles.tone2, styles.tone3, styles.tone4, styles.tone5]

export function toneClassForGroup(groups: AreaGroup[], groupId: number | null): string {
  if (groupId === null) return styles.toneNone
  const group = groups.find((candidate) => candidate.id === groupId)
  if (!group) return styles.toneNone
  if (group.primary) return styles.tonePrimary

  const ordinary = groups.filter((candidate) => !candidate.primary)
  const slot = ordinary.findIndex((candidate) => candidate.id === groupId)
  return GROUP_TONES[slot % GROUP_TONES.length]
}
